import { cn } from './utils';

export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerColor = 'accent' | 'primary' | 'inverse' | 'current';

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: SpinnerColor;
  label?: string;
  className?: string;
}

const sizeStyles: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

const colorStyles: Record<SpinnerColor, string> = {
  accent: 'border-accent',
  primary: 'border-primary',
  inverse: 'border-white',
  current: 'border-current',
};

export function Spinner({
  size = 'md',
  color = 'accent',
  label = 'Loading',
  className = '',
}: SpinnerProps) {
  const combinedClassName = cn(
    'animate-spin rounded-full border-t-2 border-b-2',
    colorStyles[color],
    sizeStyles[size],
    className,
  );

  return <div role="status" aria-label={label} aria-busy="true" className={combinedClassName} />;
}
